function MainMenu(container) {
    this.container = container;

    this.topMenu = this.container.querySelector('.jsTopMenu');
    this.menuTrigger = this.container.querySelector('.jsMenuTrigger');
    this.mainMenu = this.container.querySelector('.jsMainMenu');
    this.mainMenuWrapper = this.mainMenu.querySelector('.jsMainMenuWrapper');
    this.mainMenuInner = this.mainMenu.querySelector('.jsMainMenuInner');
    this.mainMenuItems = this.mainMenu.querySelectorAll('li');
    this.mainMenuSubParents = this.mainMenu.querySelectorAll('li.menu-item-has-children');
    this.mainMenuSubItems = this.mainMenu.querySelectorAll('.menu > li > ul');
    this.mainMenuWasWhite = this.topMenu.classList.contains('top-menu--light');
    this.topContainer = this.container.querySelector('.jsTopContainer');
    this.topContainerHadShadow = this.topContainer.classList.contains('shadow');

    this.topLogo = this.container.querySelector('.jsTopLogo');

    this.menuTrigger.addEventListener('click', e => {
        e.preventDefault();

        if (!this.mainMenu.classList.contains('open')) this.show();
        else this.hide();
    });

    this.initSubItems();

    // Hide the menu when the screen becomes too wide
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 1100) this.hide();
    });

    // Fix the submenu on tablets
    if (document.documentElement.classList.contains('mobile')) {
        this.initMobileClick();
    }

    // Hide the menu on clicking a link
    const anchorLinks = this.mainMenu.querySelectorAll('a');
    Array.prototype.forEach.call(anchorLinks, el => {
        el.addEventListener('click', e => {
            if (!el.classList.contains('touch-show-submenu')) {
                if (el.getAttribute('href') === '#') {
                    e.preventDefault();
                    return;
                }

                this.hide();
            }
        });
    });

    Array.prototype.forEach.call(this.mainMenuItems, item => {
        if (item.classList.contains('menu-item-has-children')) {
            const submenu = item.querySelector('.sub-menu');
            const menuItems = submenu.querySelectorAll('li');

            item.addEventListener('mouseenter', e => {
                if (window.innerWidth >= 850) {
                    new TimelineMax()
                        .set(menuItems, { y: 15 })
                        .to(submenu, 0.5, { opacity: 1, ease: Power2.easeInOut })
                        .staggerTo(menuItems, 1, { y: 0, ease: Power2.easeOut }, '0.1', '-=0.5')
                    ;
                }
            });
    
            item.addEventListener('mouseleave', () => {
                if (window.innerWidth >= 850) {
                    TweenLite.to(submenu, 0.5, { opacity: 0, ease: Power2.easeInOut, onComplete: () => {
                        TweenLite.set(submenu, { clearProps: 'all' });
                    } });
                }
            });
        }
    });
}

MainMenu.prototype.initSubItems = function() {
    // Don't do this on mobile devices
    if (document.documentElement.classList.contains('mobile')) return;

    const expertisesItemEl = this.topMenu.querySelector('.jsExpertisesMenuItem');
    const expertiseMenuEl = this.topMenu.querySelector('.jsExpertiseSubmenu');
    const colEls = expertiseMenuEl.querySelectorAll('.jsCol');

    expertisesItemEl.addEventListener('mouseenter', () => {
        gsap.timeline()
            .set(expertiseMenuEl, { y: 10, display: 'block', opacity: 0 })
            .set(colEls, { y: 10, opacity: 0 })

            .to(expertiseMenuEl, { duration: 0.5, y: 0, opacity: 1, ease: 'Power2.out' })
            .to(colEls, { duration: 0.5, y: 0, opacity: 1, ease: 'Power2.out', stagger: 0.05 }, '-=0.4')

            .set([expertiseMenuEl, ...colEls], { clearProps: 'all' })
        ;
    });

    expertisesItemEl.addEventListener('mouseleave', () => {
        gsap.timeline()
            .set(expertiseMenuEl, { display: 'block' })

            .to(expertiseMenuEl, { duration: 0.5, y: 10, opacity: 0, ease: 'Power2.in' })
            .to(colEls, { duration: 0.5, y: 10, opacity: 0, ease: 'Power2.in', stagger: 0.05 }, '-=0.5')

            .set([expertiseMenuEl, ...colEls], { clearProps: 'all' })
        ;
    });

    // Do the same as above for the regular menu items
    const menuItemEls = this.topMenu.querySelectorAll('.menu-item-has-children');
    menuItemEls.forEach(el => {
        el.addEventListener('mouseenter', e => {
            const subMenuEl = e.target.querySelector('ul');
            const menuItemEls = subMenuEl.querySelectorAll('li');

            gsap.timeline()
                .set(subMenuEl, { y: 10, display: 'block', opacity: 0 })
                .set(menuItemEls, { y: 10, opacity: 0 })

                .to(subMenuEl, { duration: 0.5, y: 0, opacity: 1, ease: 'Power2.out' })
                .to(menuItemEls, { duration: 0.5, y: 0, opacity: 1, ease: 'Power2.out', stagger: 0.05 }, '-=0.5')

                .set([subMenuEl, ...menuItemEls], { clearProps: 'all' })
            ;
        });

        el.addEventListener('mouseleave', e => {
            const subMenuEl = e.target.querySelector('ul');
            const menuItemEls = subMenuEl.querySelectorAll('li');

            gsap.timeline()
                .set(subMenuEl, { display: 'block' })

                .to(subMenuEl, { duration: 0.5, y: 10, opacity: 0, ease: 'Power2.in' })
                .to(menuItemEls, { duration: 0.5, y: 10, opacity: 0, ease: 'Power2.in' }, '-=0.5')

                .set([subMenuEl, ...menuItemEls], { clearProps: 'all' })
            ;
        });
    });
};

MainMenu.prototype.show = function() {
    // Scroll the window to the top and disable scrolling
    document.body.classList.add('no-scroll');
    this.topContainer.classList.remove('shadow');
    vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeInOutQuad' });

    // Show the main menu
    this.menuTrigger.classList.add('active');

    new TimelineMax()
        .set(this.mainMenuWrapper, { yPercent: -100 })
        .set(this.mainMenuInner, { yPercent: 110 })

        .set(this.mainMenuItems, { y: 15, opacity: 0 })
        .add(() => this.mainMenu.classList.add('open'))
        .add(() => this.mainMenuInner.scrollTo(0, 0))

        .to([this.mainMenuWrapper, this.mainMenuInner], 0.8, { yPercent: 0, ease: Power2.easeInOut })
        .staggerTo(this.mainMenuItems, 0.8, { y: 0, opacity: 1, ease: Power2.easeOut }, 0.1, 0.6)
    ;

    // Set the correct color classes
    this.topMenu.classList.remove('top-menu--red');
    this.topMenu.classList.remove('top-menu--orange');
    this.topMenu.classList.remove('top-menu--green');
    this.topMenu.classList.remove('top-menu--blue');
    this.topMenu.classList.remove('top-menu--light');

    this.topLogo.classList.remove('top-logo--orange');
    this.topLogo.classList.remove('top-logo--green');
    this.topLogo.classList.remove('top-logo--blue');
    this.topLogo.classList.add('top-logo--red');
};

MainMenu.prototype.hide = function() {
    if (this.topContainerHadShadow) this.topContainer.classList.add('shadow');

    // Hide the main menu
    new TimelineMax()
        .to(this.mainMenuWrapper, 0.8, { yPercent: -100, ease: Power2.easeInOut })
        .to(this.mainMenuInner, 0.8, { yPercent: 110, ease: Power2.easeInOut }, '-=0.8')
        .add(() => {
            // Set the correct color classes
            this.topMenu.classList.remove('top-menu--red');
            if (this.mainMenuWasWhite) this.topMenu.classList.add('top-menu--light');
            else this.topMenu.classList.add('top-menu--' + this.topMenu.dataset.topMenuOrigColor);

            this.topLogo.classList.remove('top-logo--red');
            this.topLogo.classList.remove('top-logo--light');
            this.topLogo.classList.add('top-logo--' + this.topLogo.dataset.topLogoOrigColor);

            this.menuTrigger.classList.remove('active');
        }, '-=0.5')
        .add(() => {
            this.mainMenu.classList.remove('open');
            
            // Enable scrolling
            document.body.classList.remove('no-scroll');
        })
    ;
};

MainMenu.prototype.initMobileClick = function() {
    if (document.documentElement.classList.contains('mobile') && window.innerWidth >= 850) {
        Array.prototype.forEach.call(this.mainMenuSubParents, item => {
            if (item.classList.contains('menu-item-has-children') && window.innerWidth >= 850) {
                const anchor = item.querySelector('a');

                anchor.addEventListener('click', e => {
                    if (! anchor.classList.contains('touch-show-submenu')) {
                        e.preventDefault();
                        e.stopPropagation();
    
                        Array.prototype.forEach.call(this.mainMenuItems, i2 => i2.querySelector('a').classList.remove('touch-show-submenu'));
                        anchor.classList.add('touch-show-submenu');
                    }
                    else {
                        Array.prototype.forEach.call(this.mainMenuItems, i2 => i2.querySelector('a').classList.remove('touch-show-submenu'));
                    }
                });
            }
        });
    }
};